import axios from '@/axios';

export async function getReasonNotCaptations(params) {
    const { data } = await axios.get("/reason_not_captureds/filter", { params });
    return data.data ? data.data : data;
}

export async function getTypeReasonNotCaptureds() {
    const { data } = await axios.get("/type_reason_not_captureds");
    return data.data ? data.data : data;
}

export async function getTypeCaptations() {
    const { data } = await axios.get("/type_captations");
    return data.data ? data.data : data;
}

export async function saveReasonNotCaptation(id, data ) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/reason_not_captureds/${id}` : `/reason_not_captureds`;
    return await axios({ method, url, data: data });
}
